import React from 'react';
import { Trans } from '@lingui/macro';
import { StickyNote, FileText } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { AiMemoView } from '../../models/AiMemo';
import { IconSparkles } from '../components/FigmaIcons';

interface AiMemoSidebarContentProps {
    currentView: AiMemoView;
    onChangeView: (view: AiMemoView) => void;
    onClose?: () => void;
    memoCount?: number;
    minutesCount?: number;
}

export const AiMemoSidebarContent: React.FC<AiMemoSidebarContentProps> = ({
    currentView,
    onChangeView,
    onClose,
    memoCount = 0,
    minutesCount = 0,
}) => {
    const handleViewChange = (view: AiMemoView) => {
        onChangeView(view);
        onClose?.();
    };

    return (
        <div className="flex flex-col bg-background rounded-panel h-full">
            {/* Header */}
            <div className="p-4 border-b">
                <div className="flex items-center gap-3">
                    <IconSparkles className="w-5 h-5 text-muted-foreground" />
                    <div className="flex flex-col min-w-0">
                        <span className="font-semibold truncate text-sm"><Trans>AI Memo</Trans> <span className="text-meta-sm font-normal text-muted-foreground">beta</span></span>
                        <span className="text-xs text-muted-foreground">
                            <Trans>AI-powered notes</Trans>
                        </span>
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
                <Button
                    variant={currentView === 'memos' ? 'secondary' : 'ghost'}
                    className="w-full justify-between font-medium text-foreground hover:bg-muted transition-colors"
                    onClick={() => handleViewChange('memos')}
                >
                    <span className="flex items-center">
                        <StickyNote className="w-4 h-4 mr-3 text-muted-foreground" /> <Trans>Memos</Trans>
                    </span>
                    {memoCount > 0 && (
                        <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">{memoCount}</span>
                    )}
                </Button>

                <Button
                    variant={currentView === 'minutes' ? 'secondary' : 'ghost'}
                    className="w-full justify-between font-medium text-foreground hover:bg-muted transition-colors"
                    onClick={() => handleViewChange('minutes')}
                >
                    <span className="flex items-center">
                        <FileText className="w-4 h-4 mr-3 text-muted-foreground" /> <Trans>Meeting Minutes</Trans>
                    </span>
                    {minutesCount > 0 && (
                        <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">{minutesCount}</span>
                    )}
                </Button>
            </nav>
        </div>
    );
};
